import React, {useMemo} from "react";
import {Form} from "antd";
import {observer} from "mobx-react";
import {useTranslate} from "../../../../hooks/translate.hook";
import {useRequiredStore} from "../../../../utils/store";
import {RootStoreContext} from "../../../../stores/root/root.store";
import {filterSystemsByAccountType, hasMissingGroup} from "./system.accesses.helpers";
import {SystemAccessesTable} from "./system.accesses.table";
import {SystemAccessesProps, SystemAccessFormValue} from "./system.accesses.types";

export const SystemAccesses: React.FC<SystemAccessesProps> = observer(({type, loading}) => {
    const t = useTranslate();
    const {
        commonStore: {systemGroups, systems},
    } = useRequiredStore(RootStoreContext);

    const availableSystems = useMemo(
        () => filterSystemsByAccountType(systems, type),
        [systems, type]
    );

    return (
        <Form.Item
            name="systemAccesses"
            rules={[
                {
                    validator: async (_, accesses?: SystemAccessFormValue[]) => {
                        if (!accesses?.length) {
                            throw new Error(t("FROM.ERROR.PLEASE_ADD_VALUE"));
                        }
                        if (hasMissingGroup(accesses)) {
                            throw new Error(t("FROM.ERROR.PLEASE_SELECT_VALUE"));
                        }
                    },
                },
            ]}
        >
            <SystemAccessesTable
                systems={availableSystems}
                systemGroups={systemGroups}
                loading={loading}
                systemsLoading={systems.length === 0}
                groupsLoading={systemGroups.length === 0}
            />
        </Form.Item>
    );
});
